import Swal from 'sweetalert2';
import CargandoModule from "@/store/modules/cargando-module";
export default class MessageService {

    public TypeSuccess = 'success';
    public TypeError = 'error';
    public TypeWarning = 'warning';
    public TypeInfo = 'info';
    public TypeQuestion: any = 'question';

    public PositionTop = 'top';
    public PositionTopStart = 'top-start';
    public PositionTopEnd = 'top-end';
    public PositionCenter = 'center';
    public PositionCenterStart = 'center-start';
    public PositionCenterEnd = 'center-end';
    public PositionBottom = 'bottom';
    public PositionBottomStart = 'bottom-start';
    public PositionBottomEnd = 'bottom-end';

    private defaultTimeout = 3000;
    private customClass = '';
    private animation = true;

    public setCustomClass(customClass: string) {
        this.customClass = customClass;
    }

    public setAnimation(animation: boolean) {
        this.animation = animation;
    }

    // Aviso flotante que desaparece solo tras un tiempo
    public toast(texto: string, tipo: any = this.TypeSuccess, timeout: number = this.defaultTimeout,
        posicion: any = this.PositionTop,
        customClass: any = this.customClass, animation: boolean = this.animation) {
        return Swal({
            position: posicion,
            showConfirmButton: false,
            timer: timeout,
            title: texto,
            toast: true,
            type: tipo,
            customClass,
            animation,
        });
    }

    // Aviso flotante que desaparece solo tras un tiempo
    public toastsuccesful(texto: string) {
        let tipo = this.TypeSuccess;
        let timeout = this.defaultTimeout;
        let position = this.PositionTop;
        let animation = true;
        let customClass = '';
        this.toast(texto, tipo, timeout, position, customClass, animation);
    }

    // Aviso flotante que desaparece solo tras un tiempo
    public toastinfo(texto: string) {
        let tipo = this.TypeWarning;
        let timeout = 100000;// this.defaultTimeout;
        let position = this.PositionTop;
        let animation = true;
        let customClass = '';
        return this.toast(texto, tipo, timeout, position, customClass, animation);
    }

    public alert(titulo: string, texto: string = '', tipo: any = this.TypeSuccess,
        timeout: number = this.defaultTimeout, posicion: any = this.PositionCenter,
        customClass: any = this.customClass, animation: boolean = this.animation) {
        Swal({
            position: posicion,
            text: texto,
            timer: timeout,
            title: titulo,
            type: tipo,
            customClass,
            animation,
        });
    }
    public alertRespose(titulo: string, texto: string = '', cb: (res: boolean) => void, tipo: any = this.TypeSuccess,
        timeout: number = this.defaultTimeout, posicion: any = this.PositionCenter,
        customClass: any = this.customClass, animation: boolean = this.animation) {
        Swal({
            position: posicion,
            text: texto,
            timer: timeout,
            title: titulo,
            type: tipo,
            customClass,
            animation,
        }).then((result: any) => {
            if (result.value) {
                cb(true);
            } else {
                cb(false);
            }
        });
    }
    public confirm(texto: string, titulo = 'Pregunta', cb: (res: boolean) => void,
        customClass: any = this.customClass, animation: boolean = this.animation) {
        Swal({
            cancelButtonText: 'No',
            confirmButtonText: 'Si',
            showCancelButton: true,
            text: texto,
            title: titulo,
            type: this.TypeQuestion,
            customClass,
            animation,
        }).then((result: any) => {
            if (result.value) {
                cb(true);
            } else {
                cb(false);
            }
        });
    }

    public showLoading(customClass: any = this.customClass) {
        /* Swal({
             title: 'Cargando . . .',
             customClass,
         });
         Swal.showLoading();*/
        CargandoModule.ShowEspera()
    }

    public hideLoading() {
        // Swal.close();
        CargandoModule.CloseEspera()
    }
}

export const ssmMessageService = new MessageService();
